"use strict";

const searchURL = `/search?view=ajax&q=%queryString%&sort_by=%sortBy%`;

const getSortedData = (data, prop, isAsc) => {
  return data.sort((a, b) => {
    let ret;
    if (prop === "price") {
      ret = a.dataset[prop] - b.dataset[prop];
    } else {
      if (a.dataset[prop] < b.dataset[prop]) {
        ret = -1;
      } else if (a.dataset[prop] > b.dataset[prop]) {
        ret = 1;
      } else {
        ret = 0;
      }
    }
    return isAsc ? ret : -ret;
  });
};

export const collectionSortBy = (field, dir = "asc") => {
  const $wrapper = $(".collection-grid");
  const sortedList = getSortedData(
    $wrapper.find(".grid-item"),
    field,
    dir === "asc",
  );
  $wrapper.html(sortedList);
};

export const performSearch = (queryString, sortBy, container) => {
  const finalSearchURL = searchURL
    .replace("%queryString%", queryString)
    .replace("%sortBy%", sortBy);
  $.get(finalSearchURL, function (response) {
    if (response.trim() === "no results") {
      container.innerHTML = container._topContent || "";
    } else {
      container.innerHTML = response;
    }
  });
};

export const toggleLiveSearch = (body, searchWidget, searchInputs) => {
  body.classList.toggle("live-search-is-active");
  searchWidget.classList.toggle("is-active");
  searchInputs.forEach((input) => {
    input.focus();
  });
};
